import { render, staticRenderFns } from "./CommentCountParts.vue?vue&type=template&id=38c00977&scoped=true"
import script from "./CommentCountParts.vue?vue&type=script&lang=ts"
export * from "./CommentCountParts.vue?vue&type=script&lang=ts"
import style0 from "./CommentCountParts.vue?vue&type=style&index=0&id=38c00977&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c00977",
  null
  
)

export default component.exports